import React, {useRef} from "react";
import billPrintFromTableStyle from "./billPrintFromTableStyle";
import {useState, useContext, forwardRef, useEffect} from "react";
import ReactToPrint, {PrintContextConsumer} from "react-to-print";
import {PrintDataContext} from "../../Pages";
import commaSeparator from "../../utils/CommaSeparator";
import PaperWidthToUse from "../BarcodeLabel/PaperWidthToUse";
import BillPrint from "./BillPrint";
import FishHoqoqi from "./fish/FishHoqoqi";
import PrintType7 from "./PrintType7/PrintType7";
import PrintLedger from "../Printpage/PrintLedger";
import {useNavigate} from "react-router-dom";
import PrintFactorBuySadan from "./TypePrintSadanShop/PrintFactorBuySadan";
import ReviewAccountsPrint from "./TypePrintSadanShop/ReviewAccountsPrint";
import ControlUnderTablePrint from "./TypePrintSadanShop/ControlUnderTablePrint";
import PrintTypeSellFactor from "./PrintTypeSellFactor/PrintTypeSellFactor";
import BalanceSheetPrint from "./TypePrintSadanShop/BalanceSheetPrint";
import CostAndBenefitPrint from "./TypePrintSadanShop/CostAndBenefitPrint";
import NoteBookReportPrint from "./TypePrintSadanShop/NoteBookReportPrint";
import NoteBookReportPrintTwo from "./TypePrintSadanShop/NoteBookReportPrintTwo";
import ReviewAccountsPrintTwo from "./TypePrintSadanShop/ReviewAccountsPrintTwo";
import AnipoPrint3 from "./AnipoPrint/AnipoPrint3/AnipoPrint3";
import AnipoPrint4 from "./AnipoPrint/AnipoPrint4/AnipoPrint4";
import SingleReportPrint from "./ReportPrint/SingleReportPrint";
import SellFactorPostPrint from "./SellFactorPostPrint/SellFactorPostPrint";
import FactorPrint8Cm from "./FactorPrint8cm/FactorPrint8cm";
import BarcodePrint from "./BarcodePrint/BarcodePrint";
import QAFormPrint from "./ArkaPrintPages/QAFormPrint/QAFormPrint";
import ListOfApIs from "./ArkaPrintPages/listOfAPIs/listOfAPIs";
import ListOfVersions from "./ArkaPrintPages/ListOfVersions/ListOfVersions";
import CharacteristicsOfRelationships
  from "./ArkaPrintPages/CharacteristicsOfRelationships/CharacteristicsOfRelationships";
import ErDiagram from "./ArkaPrintPages/ErDiagram/ErDiagram";
import Domains from "./ArkaPrintPages/Domains/Domains";
import AnalysisList from "./ArkaPrintPages/AnalysisList/AnalysisList";
import Relationships from "./ArkaPrintPages/Relationships/Relationships";
import ListOfSubsystems from "./ArkaPrintPages/ListOfSubsystems/ListOfSubsystems";
import NeedsAnalysisForm from "./ArkaPrintPages/NeedsAnalysisForm/NeedsAnalysisForm";
import ReportAnalysisForm from "./ArkaPrintPages/ReportAnalysisForm/ReportAnalysisForm";
import ListOfForms from "./ArkaPrintPages/ListOfForms/ListOfForms";
import ShowForm from "./ArkaPrintPages/ShowForm/ShowForm";

const InTable = (props) => {
  const {mapData} = props;
  try {
    return (
      <>
        {mapData.map((v) => (
          <>
            {!v.subList && (
              <>
                <ul className="text-end py-1 px-3 d-flex">
                  <li className={"text-center li-width"}>{v.id}</li>
                  <li className={" ltr text-center fd-font w-50"}>
                  <span className={"px-2"}>
                    {Number(v.price).toLocaleString()}
                  </span>
                  </li>
                </ul>
              </>
            )}
            {v.subList && (
              <ul className="text-end  px-3 d-flex">
                <li className="text-end py-1 px-3 ">
                  <span className={""}>{v.id}</span>:
                </li>
                <li className={"printMainDivStyle "}>
                  {v.data.map((subListValue) => (
                    <ul className="text-end py-1 px-3 d-flex">
                      <li className={"text-center"}> {subListValue.name} :</li>
                      <li className={" ltr fd-font "}>
                        {" "}
                        {Number(subListValue.price).toLocaleString()}{" "}
                      </li>
                    </ul>
                  ))}
                </li>
              </ul>
            )}
          </>
        ))}
      </>
    );
  } catch (error) {
    return <>{error.toLocaleString()}</>
  }

};
const ComponentToPrint = forwardRef((props, ref) => {
  const dataprint1 = useContext(PrintDataContext);

  const [balanceTableData, setBalanceTableData] = useState(dataprint1);

  const printDom = useRef(null);
  const tableRef = useRef(null);

  let fieldArray = [];
  if (dataprint1.type === "tablePrint") {
    for (const dataIn in dataprint1.data) {
      let tempArray = [];
      dataprint1.data[dataIn].column.map(
        (p) => tempArray.push(p.field) // console.log(p.field + " : " + dataIn)
      );
      fieldArray.push(tempArray);
    }
  }

  const nullToZero = (input) => (input === null ? 0 : input);
  const processData = (inputObject) => {
    let rowData = "";
    // //debugger
    let rtValue = 0;
    for (let item of inputObject) {
      if (item.subList === false) {
        rtValue = rtValue + +nullToZero(item.price);
        // console.log("sum: " + sum ,"item:" + item , "subExpenseItemElement:"+ "-" )
        rowData += (
          <div className="text-end py-3 px-3">
            {" "}
            {item.id} :{" "}
            <div className={"ltr d-inline-block fd-font"}>
              {Number(item.price).toLocaleString()}
            </div>
          </div>
        );
        // tempResult=  <div className="text-end py-3 px-3">  {item.id} : <div className={"ltr d-inline-block fd-font"}>{Number(item.price).toLocaleString()}</div></div>
      } else {
        for (let subExpenseItemElement of item.data) {
          rtValue = rtValue + +nullToZero(subExpenseItemElement.price);
          rowData += (
            <div className="text-end py-3 px-3 mx-5">
              {" "}
              {item.id} :{" "}
              <div className={"ltr d-inline-block fd-font"}>
                {Number(item.price).toLocaleString()}
              </div>
            </div>
          );
        }
      }
    }
    const resultHtml = <>{rowData}</>;
    return {rtValue, resultHtml};
  };

  const [sumItems, setSumItems] = useState({
    expenseSum: "",
    expenseSumJsx: "",
    incomeSum: "",
    incomeSumJsx: "",
  });

  const $ = (q) => document.querySelector(q);

  const innerTextData = (id, label, value) => {
    // //debugger;
    const element = [...document.querySelectorAll(`#${id}`)];

    element.map((item) => {
      if ($(`#${id}`)) {
        item.children[0].textContent = label;
        // جمع کل رو سه رقم جدا کن
        if (id === "Memo67" || id === "Memo65") {
          item.children[1].textContent = commaSeparator(value);
        } else {
          item.children[1].textContent = value;
        }
        if (value !== "0") {
          item.classList.remove("d-none");
        }
      }
    });
  };

  const [barcodeData, setBarcodeData] = useState("");
  useEffect(() => {
    if (dataprint1.type === "tablePrint") {
      dataprint1.headerAndFooter.header.map((item) => {
        // console.log(item.id)
        let headerItem = printDom.current.querySelector(`#${item.id}`);
        let textValue = item.value;
        if (headerItem !== null) {
          if (headerItem.tagName === "IMG") {
            headerItem.src = "../" + textValue;
          } else {
            headerItem.innerText = textValue;
          }
        }
      });
    }
    if (dataprint1.type === "billPrintFromTable") {
      if (ref?.current) {
        //logo
        for (let item of dataprint1.headerAndFooter.header) {
          if (item.id === "Memo100") {
            document.getElementsByClassName(
              "bill__logo"
            )[0].innerHTML = `<img className="img-fluid" src ="${item.value}"  alt="لوگو"/>`;
          }
        }

        for (let item of dataprint1.headerAndFooter.detail) {
          if (item.id === "Memo72") {
            setBarcodeData(item.value);
          }
        }

        let [columns, data] = [``, ``];

        // ! Header (Info) & Footer (End)
        ["header", "user", "detail", "text"].map((item) => {
          dataprint1.headerAndFooter[item].map((item) => {
            innerTextData(item.id, item.label.split("/")[0], item.value);
          });
        });
        // ! Body (Data)
        // Get Columns
        columns += `<td>ردیف</td>`;
        // //debugger

        // dataprint1.data[0].column.map((item) => {
        //   columns += `<td>${item.title}</td>`
        // })
        Object.entries(dataprint1.data[0].column).forEach(([value]) => {
          // console.log(key, value);
          columns += `<td>${value.title}</td>`;
        });

        // Get Data's
        dataprint1.data[0].data.map((item, number) => {
          // اینجا نگاه میکنم

          data += `<tr>
                        <td>${number + 1}</td>
                        <td>${item?.CKALA}</td>
                        <td>${item?.NKALA}</td>
                        <td>${commaSeparator(item?.GHVAHED)}</td>
                        <td>${item?.TE}</td>
                        <td>${commaSeparator(item?.JAM)}</td>
                    </tr>`;
        });
        // Append Data & Columns
        $("#columns").innerHTML = columns;
        $("#data").innerHTML = data;
      }
    }
  }, []);

  useEffect(() => {
    let data = balanceTableData;
    let expenseSum = {rtValue: "", resultHtml: ""};
    let incomeSum = {rtValue: "", resultHtml: ""};
    if (data.type === "costAndBenefit" || data.type === "balance") {
      expenseSum = processData(dataprint1.data?.expense);
      incomeSum = processData(dataprint1.data?.income);
    }

    setSumItems({
      expenseSum: expenseSum.rtValue,
      expenseSumJsx: expenseSum.resultHtml,
      incomeSum: incomeSum.rtValue,
      incomeSumJsx: incomeSum.resultHtml,
    });
  }, []);

  if (balanceTableData.type === "balance") {
    return (
      <>
        <style>{billPrintFromTableStyle}</style>
        <div className={"printMainDivStyle"} ref={ref}>
          <div className={"row "}>
            <div className={"col-12 text-center mt-5"}>
              <div className={"text-center fw-bold mb-3"}>ترازنامه</div>
              <div className={"text-center "}>
                {balanceTableData.header?.shopName}
              </div>
              <div className={"text-center my-2"}>{dataprint1.title}</div>
              <div className={"text-center mb-2"}>
                {balanceTableData.header.date}
              </div>
            </div>
            <div className="rounded border border-dark row px-0">
              <div
                className={"col-6 px-0 border-start border-dark position-relative"}>
                <div className={"text-center  border-bottom border-dark py-3"}>
                  دارایی ها
                </div>
                <InTable mapData={balanceTableData.data.income}/>

                <div className="text-end py-3 px-3">
                  &nbsp;<span>&nbsp;</span>
                </div>

                <div
                  className={"border-top border-dark py-3 position-absolute bottom-0   text-center w-100"}>
                  جمع :
                  <div className={"ltr d-inline-block fd-font"}>
                    {sumItems.incomeSum}
                  </div>
                </div>
              </div>
              <div className={"col-6 px-0 border-dark position-relative"}>
                <div className={"text-center  border-bottom border-dark py-3"}>
                  بدهی ها
                </div>
                <InTable mapData={balanceTableData.data.expense}/>
                <div className="text-end py-3 px-3">
                  &nbsp;<span>&nbsp;</span>
                </div>
                <div
                  className={"border-top border-dark py-3 position-absolute bottom-0  text-center w-100 "}>
                  {" "}
                  جمع :
                  <div className={"ltr d-inline-block fd-font"}>
                    {sumItems.expenseSum}
                  </div>
                </div>
              </div>
              <div
                className={"col-6 px-0 border-dark position-relative border-top w-100"}>
                <div className={"my-2"}>
                  جمع کل: &nbsp;&nbsp;&nbsp;
                  <div className={"ltr d-inline-block fd-font"}>
                    {sumItems.incomeSum - sumItems.expenseSum}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (balanceTableData.type === "costAndBenefit") {
    return (
      <>
        <style>{billPrintFromTableStyle}</style>
        <div className={"printMainDivStyle"} ref={ref}>
          <div className={"row "}>
            <div className={"col-12 text-center mt-5"}>
              <div className={"text-center fw-bold mb-3"}>گزارش سود و زیان</div>
              <div className={"text-center"}>
                {balanceTableData.header.shopName}
              </div>
              <div className={"text-center my-2"}>{dataprint1.title}</div>
              <div className={"text-center mb-2"}>
                {balanceTableData.header.date}
              </div>
            </div>
            <div className="rounded border border-dark row px-0">
              <div
                className={"col-6 px-0 border-start border-dark position-relative"}>
                <div className="cell-head">فروش کل</div>
                <div className="cell-benefit"> گروه هزینه</div>

                {balanceTableData.data.expense[1].data.map((item) => (<div className="cell-benefit">{item.name}</div>))}
                <div className="cell-head">جمع کل</div>
              </div>
              <div className={"col-6 px-0 border-dark position-relative"}>
                <div className="cell-head">
                  {balanceTableData.data.income[0].price}
                </div>
                <div className="cell-benefit"> مبلغ</div>
                {balanceTableData.data.expense[1].data.map((item) => (
                  <div className="cell-benefit">{item.price}</div>))}
                <div className="cell-head">
                  {balanceTableData.data.income[0].price - sumItems.expenseSum}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (balanceTableData.type === "tablePrint") {
    // جدول
    return (
      <>
        <style>{billPrintFromTableStyle}</style>
        <div ref={ref} className={"position-relative"}>
          <div ref={tableRef} className={"iwannaTestit"}>
            <div className="print-container position-relative" ref={printDom}>
              {/**/}
              <div className="header">
                <div className="rowHeader">
                  <div className="client-info">
                    <div id="Memo69"></div>
                    <div id="Memo62"></div>
                    <div id="Memo60"></div>
                  </div>
                  <div className="topHeader ">
                    <h1 className="font" id="Memo10"></h1>
                    <h2 id="124" className="font">
                      {dataprint1.title}
                    </h2>
                  </div>
                  <div className="logo">
                    <img id="Memo100" src="" alt={""}/>
                  </div>
                </div>
              </div>
              <div className="footer">
                <div className="rowFooter ">
                  <div className="fontSize firstCulmn">
                    {dataprint1.headerAndFooter.detail.map((item) => (<ul>
                      <li>{item.label}</li>
                      <li>{item.value}</li>
                    </ul>))}
                  </div>
                  <div className="fontSize secondCulmn">
                    <span>
                      {dataprint1.headerAndFooter.text[0] && dataprint1.headerAndFooter.text[0].value}
                    </span>
                  </div>
                  <div className="fontSize thirdCulmn">
                    {dataprint1.headerAndFooter.user.map((item) => (<ul>
                      <li>{item.label}</li>
                      <li>{item.value}</li>
                    </ul>))}
                  </div>
                </div>
              </div>
              {/**/}

              <table className="mainCont">
                <thead className={"header-space"}>
                <td colSpan={4} className={"tdStyleHead"}></td>
                </thead>
                {/**/}
                <tbody>
                {dataprint1.data.map((tabledata, index) => (<>
                  <tr>
                    <th className={"headerStyleForTable"} colSpan="4">
                      {tabledata.entityName}
                    </th>
                  </tr>
                  <tr>
                    {tabledata.column.map((p) => (<th>{p.title}</th>))}
                  </tr>
                  {tabledata.data.map((key) => (<tr>
                    {fieldArray[index].map((input) => (<td>{key[input]}</td>))}
                  </tr>))}
                </>))}
                </tbody>

                <tfoot className={"footer-space"}>
                <td colSpan={4} className={"tdStyleHead"}></td>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (balanceTableData.type === "billPrintFromTable") {
    console.log(balanceTableData);
    return (
      <div ref={ref}>
        <BillPrint barcodeData={barcodeData}/>
      </div>
    );
  }

  if (balanceTableData.type === "barcodePrintFromBuyBill") {
    return (
      <div ref={ref}>
        {balanceTableData.data.length > 0 && (
          <PaperWidthToUse
            paperWidth={balanceTableData.data[0].paperWidth}
            barcodeLength={balanceTableData.data[0].barcodeLength}
            barcodeWidth={balanceTableData.data[0].barcodeWidth}
            productFont={balanceTableData.data[0].productFont}
            barcodeCount={balanceTableData.data[0].barcodeCount}
            priceFont={balanceTableData.data[0].priceFont}
            data={balanceTableData.data}
          />
        )}
      </div>
    );
  }

  if (balanceTableData.type === "fish") {
    debugger;
    console.log(balanceTableData);
    return (<>
      <div ref={ref}>
        <FishHoqoqi data={balanceTableData}/>
      </div>
    </>);
  }

  if (balanceTableData.type === "printType7" || balanceTableData.type === "HAVALEANBAR") {
    if (balanceTableData.entityName === "FAKKOLSELL") {
      if (balanceTableData.sellFactorPrintSize === "8cm") {
        return (<div ref={ref}>
          <PrintType7 data={balanceTableData}/>
        </div>);
      } else if (balanceTableData.sellFactorPrintSize === "A4" ||
        balanceTableData.sellFactorPrintSize === "A5") {
        return <div ref={ref}>
          <PrintTypeSellFactor data={balanceTableData}/>
        </div>

      } else {
        return <div ref={ref}>
          کلید (sellFactorPrintSize)سایز پرینت در چاپ فاکتور فروش اجباری است.
        </div>
      }

    } else {
      return (<div ref={ref}>
        <PrintType7 data={balanceTableData}/>
      </div>);
    }
  }

  if (balanceTableData.type === "ledger") {
    return (<div ref={ref}>
      <PrintLedger data={balanceTableData}/>
    </div>);
  }

  if (balanceTableData.type === undefined) {
    debugger;
    console.log(balanceTableData);
    return (<>
      <style>{billPrintFromTableStyle}</style>
      <div ref={ref}>
        <h2
          style={{display: "block", width: "100%", direction: "rtl"}}
          className={"text-center"}
        >
          چیزی برای پرینت وجود ندارد!
        </h2>
      </div>
    </>);
  }

  if (balanceTableData.type === "PrintFactorBuySadan") {
    return (<div ref={ref} className={'w-100'}>
      <PrintFactorBuySadan data={balanceTableData}/>
    </div>);
  }

  if (balanceTableData.type === "ReviewAccountsPrint") {
    return (<div ref={ref} className={'w-100'}>
      <ReviewAccountsPrint data={balanceTableData}/>
    </div>);
  }

  if (balanceTableData.type === "ReviewAccountsPrintTwo") {
    return (<div ref={ref} className={'w-100'}>
      <ReviewAccountsPrintTwo data={balanceTableData}/>
    </div>);
  }

  if (balanceTableData.type === "ControlUnderTablePrint") {
    return (<div ref={ref} className={'w-100'}>
      <ControlUnderTablePrint data={balanceTableData}/>
    </div>);
  }

  if (balanceTableData.type === "BalanceSheetPrint") {
    return (<div ref={ref} className={'w-100'}>
      <BalanceSheetPrint data={balanceTableData}/>
    </div>);
  }

  if (balanceTableData.type === "CostAndBenefitPrint") {
    return (<div ref={ref} className={'w-100'}>
      <CostAndBenefitPrint data={balanceTableData}/>
    </div>);
  }

  if (balanceTableData.type === "NoteBookReportPrint") {
    return (<div ref={ref} className={'w-100'}>
      <NoteBookReportPrint data={balanceTableData}/>
    </div>);
  }

  if (balanceTableData.type === "NoteBookReportPrintTypeTwo") {
    return (<div ref={ref} className={'w-100'}>
      <NoteBookReportPrintTwo data={balanceTableData}/>
    </div>);
  }

  if (balanceTableData.type === "ANIPO_Print3") {
    return (<div ref={ref} className={'w-100'}>
      <AnipoPrint3 data={balanceTableData}/>
    </div>);
  }

  if (balanceTableData.type === "ANIPO_Print4") {
    return (<div ref={ref} className={'w-100'}>
      <AnipoPrint4 data={balanceTableData}/>
    </div>);
  }

  if (balanceTableData.type === "SingleReport") {
    return (<div ref={ref} className={'w-100'}>
      <SingleReportPrint data={balanceTableData}/>
    </div>);
  }

  if (balanceTableData.type === "SellFactorPostPrint") {
    return (<div ref={ref} className={'w-100'}>
      <SellFactorPostPrint data={balanceTableData}/>
    </div>);
  }

  if (balanceTableData.type === "FactorPrint8cm") {
    return (<div ref={ref} className={'w-100'}>
      <FactorPrint8Cm data={balanceTableData}/>
    </div>);
  }

  if (balanceTableData.type === "BarcodeDataPrint") {
    return (<div ref={ref} className={'w-100'}>
      <BarcodePrint data={balanceTableData}/>
    </div>);
  }

  // ArkaPrintPages
  if (balanceTableData.type === "QAForm") {
    return (<div ref={ref} className={'w-100'}>
      <QAFormPrint data={balanceTableData}/>
    </div>);
  }
  if (balanceTableData.type === "listOfAPIs") {
    return (<div ref={ref} className={'w-100'}>
      <ListOfApIs data={balanceTableData}/>
    </div>);
  }
  if (balanceTableData.type === "listOfVersions") {
    return (<div ref={ref} className={'w-100'}>
      <ListOfVersions data={balanceTableData}/>
    </div>);
  }
  if (balanceTableData.type === "characteristicsOfRelationships") {
    return (<div ref={ref} className={'w-100'}>
      <CharacteristicsOfRelationships data={balanceTableData}/>
    </div>);
  }
  if (balanceTableData.type === "ErDiagram") {
    return (<div ref={ref} className={'w-100'}>
      <ErDiagram data={balanceTableData}/>
    </div>);
  }
  if (balanceTableData.type === "domains") {
    return (<div ref={ref} className={'w-100'}>
      <Domains data={balanceTableData}/>
    </div>);
  }
  if (balanceTableData.type === "analysisList") {
    return (<div ref={ref} className={'w-100'}>
      <AnalysisList data={balanceTableData}/>
    </div>);
  }
  if (balanceTableData.type === "relationships") {
    return (<div ref={ref} className={'w-100'}>
      <Relationships data={balanceTableData}/>
    </div>);
  }
  if (balanceTableData.type === "listOfSubsystems") {
    return (<div ref={ref} className={'w-100'}>
      <ListOfSubsystems data={balanceTableData}/>
    </div>);
  }
  if (balanceTableData.type === "needsAnalysisForm") {
    return (<div ref={ref} className={'w-100'}>
      <NeedsAnalysisForm data={balanceTableData}/>
    </div>);
  }
  if (balanceTableData.type === "reportAnalysisForm") {
    return (<div ref={ref} className={'w-100'}>
      <ReportAnalysisForm data={balanceTableData}/>
    </div>);
  }
  if (balanceTableData.type === "listOfForms") {
    return (<div ref={ref} className={'w-100'}>
      <ListOfForms data={balanceTableData}/>
    </div>);
  }
  if (balanceTableData.type === "showForm") {
    return (<div ref={ref} className={'w-100'}>
      <ShowForm data={balanceTableData}/>
    </div>);
  }
  // ArkaPrintPages
});

const FactorPrint = () => {
  const myRef = useRef();
  const navigateTo = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      document.getElementById("printButton").click();
    }, 100);
  });

  try {
    return (<>
      <div className={"printBalanceBenefit"} style={{width: "100%", height: "75vh", overflow: "scroll"}}>
        <div>
          <ReactToPrint
            content={() => myRef.current}
            // onBeforeGetContent={ () => {
            //   const totalPages = Math.ceil(myData.length / 20); // Assuming 20 rows per page, adjust as needed
            //   setPageNumber(1);
            //   for (let page = 1; page < totalPages; page++) {
            //     setTimeout(() => setPageNumber(page + 1), 0); // Delay setting the page number to allow it to update on each page
            //   }
            // }}
            onAfterPrint={() => navigateTo(-1)}
          >
            <PrintContextConsumer>
              {({handlePrint}) => (<button
                id={"printButton"}
                className={"btnCustom btnSubmit"}
                onClick={handlePrint}>
                چاپ
              </button>)}
            </PrintContextConsumer>
          </ReactToPrint>
        </div>
        <div style={{maxWidth: "50vw", margin: "0 auto"}} className={"mt-3"}>
          <ComponentToPrint ref={myRef}/>
        </div>
      </div>
    </>);
  } catch (error) {
    return <>{error.toLocaleString()}</>
  }
};

export default React.memo(FactorPrint);
